import { push } from 'react-router-redux';
import ga from 'react-ga';

import Fetch from 'network';
import { showNotificationWithTimeout as notify } from 'actioncreators/notification';

let opener = null;
if (window.opener !== null) {
  opener = window.opener;
}

export const getOpener = () => {
  return opener;
};

export const getScrollYPositon = () => {
  const rect = document.body.getBoundingClientRect();
  const windowHeight = window.innerHeight;
  return ((rect.height - windowHeight) - window.pageYOffset);
};

export const loadAndSetCrop = (image, dispatch) => {
  if (!getOpener()) {
    return;
  }
  Fetch.put('/images/' + image.id + '/use', {}, (res) => {
    setGlobalImage(image, res);
  }, (err) => {
    if (err.status === 404) {
      dispatch(notify('No crop exists for this image. Please create one first.', 'error'));
      dispatch(push({
        pathname: '/image/' + image.id + '/crop',
      }));
    }
  });
};

export let globalImage = null;

export const getGlobalImage = () => globalImage;

export const setGlobalImage = (image, crop) => {
  console.log(image, crop);
  const gi = {};
  gi.credit = image.credit;
  gi.exif_caption = image.exif_caption;
  gi.caption = image.caption;
  gi.credit_link = image.credit_link;
  Object.keys(crop.crops).forEach(key => {
    gi[key] = crop.crops[key];
  });
  globalImage = gi;
  if (opener !== null) {
    ga.event({
      category: 'Crops',
      action: 'Crops exported to CMS',
    });
    window.opener.postMessage(JSON.stringify(globalImage));
  }
};

let suggestedKeywords = [];
let popCount = 0;

export const setSuggestedKeywords = (keywords) => {
  suggestedKeywords = keywords.split(',').map(kw => kw.trim());
};

export const getSuggestedKeywords = () => {
  if (popCount < 2) {
    popCount++;
    return suggestedKeywords;
  }
  const retVal = suggestedKeywords;
  suggestedKeywords = [];
  return retVal;
};

export const resetSuggestedKeywords = () => {
  suggestedKeywords = [];
};



/** WEBPACK FOOTER **
 ** ./util/window.js
 **/